export function locationListToggle() {
  const list = document.querySelector(".object-category-location ul");
  const btn = document.querySelector("[data-toggle-list]");

  if (!btn || !list) return;

  btn.addEventListener("click", function() {
    list.classList.toggle("expanded");
    btn.classList.toggle('active');
    btn.textContent = list.classList.contains("expanded")
      ? "Приховати"
      : "Розгорнути весь список";
  });
}